import React, { useCallback, useEffect, useRef, useState } from 'react';
import SearchIcon from '@mui/icons-material/Search';
import { useTenantContext } from '../../../tenant/TenantContext';
import { useNavigate } from 'react-router-dom';
import { useFilterContext } from '../infrastructure/FilterContext';
import { useDebouncedEffect } from '../../../common/utils/useDemouncedEffect';
import { useComercialContext } from '../../../comercial/ComercialContext';
import { fetchSuggestions } from '../infrastructure/CatalogService';

import {
    SearchWrapper,
    SearchContainer,
    SearchInput,
    SearchIconWrapper,
    SuggestionsDropdown,
    SuggestionItem,
    SuggestionThumb,
    SuggestionName,
} from './filter-panel/ProductSearchFilter.styles';

export const ProductSearchFilter = () => {
    useTenantContext();
    const { updateFilters, filters } = useFilterContext();
    const { actingAsCliente } = useComercialContext();
    const [searchString, setSearchString] = useState(filters?.search || '');
    const [suggestions, setSuggestions] = useState([]);
    const [showSuggestions, setShowSuggestions] = useState(false);
    const containerRef = useRef(null);
    const navigate = useNavigate();

    const searchProduct = useCallback(
        (searchTerm) => {
            setShowSuggestions(false);
            setSuggestions([]);
            updateFilters({ search: searchTerm });
            navigate('/articulos');
        },
        [navigate, updateFilters]
    );

    const handleChange = (event) => {
        event.preventDefault();
        const value = event.target.value;
        setSearchString(value);
        if (value.length < 3) {
            setSuggestions([]);
            setShowSuggestions(false);
        }
    };

    const handleKeyDown = (event) => {
        if (event.key === 'Enter') {
            event.preventDefault();
            searchProduct(searchString);
        }
        if (event.key === 'Escape') {
            setShowSuggestions(false);
        }
    };

    useDebouncedEffect(() => {
        if (searchString.length < 3) return;
        const actingAs = actingAsCliente?.numCliente ?? null;
        fetchSuggestions(searchString, actingAs).then((result) => {
            if (result.state === 'success' && Array.isArray(result.value)) {
                setSuggestions(result.value);
                setShowSuggestions(result.value.length > 0);
            }
        });
    }, [searchString, actingAsCliente], 250);

    useEffect(() => {
        const handleClickOutside = (e) => {
            if (containerRef.current && !containerRef.current.contains(e.target)) {
                setShowSuggestions(false);
            }
        };
        document.addEventListener('mousedown', handleClickOutside);
        return () => document.removeEventListener('mousedown', handleClickOutside);
    }, []);

    useEffect(() => {
        setSearchString(filters?.search || '');
    }, [filters]);

    return (
        <div className="w-100 d-flex flex-column gap-2 align-items-center" ref={containerRef}>
            <SearchWrapper>
                <SearchContainer>
                    <SearchInput
                        placeholder="Busca aquí tus productos"
                        value={searchString}
                        onChange={handleChange}
                        onKeyDown={handleKeyDown}
                        type="text"
                    />
                    <SearchIconWrapper onClick={() => searchProduct(searchString)}>
                        <SearchIcon />
                    </SearchIconWrapper>
                </SearchContainer>
                {showSuggestions && suggestions.length > 0 && (
                    <SuggestionsDropdown>
                        {suggestions.map((s) => (
                            <SuggestionItem
                                key={s.codigo}
                                onMouseDown={(e) => {
                                    e.preventDefault();
                                    searchProduct(s.nombre);
                                }}
                            >
                                {s.imagenPrincipal && (
                                    <SuggestionThumb src={s.imagenPrincipal} alt="" />
                                )}
                                <SuggestionName>{s.nombre}</SuggestionName>
                            </SuggestionItem>
                        ))}
                    </SuggestionsDropdown>
                )}
            </SearchWrapper>
        </div>
    );
};
